import styled from 'styled-components';

import {
  colors,
  layers,
} from '../../theme';

export const Wrapper = styled.section`
  height: calc(100vh - 3rem);
  position: relative;
  z-index: 10;
  background: ${colors.GREY__WHITE};
  top: 0;
  width: 100%;
  overflow: hidden;
  z-index: ${layers.INTRO};

  &.inactive > * {
    display: none;
  }

  html.touch & {
    height: calc(100vh - 3rem - 88px);
  }
`;

export const Items = styled.div``;

export const Item = styled.div``;



// WEBPACK FOOTER //
// ./src/components/Intro/style.js